(function() {
'use strict';

angular
    .module('TR')
    .controller('TestPage', TestPage);

function TestPage() {
    const cm = this;

    cm.announcements = [
        {
            id: 'ebola-travel-advisory',
            title: 'Travel advisory – Ebola-related measures in several countries including the UAE. Check destination entry requirements before travel.',
            body: 'Several countries have implemented travel entry restrictions and/or enhanced screening measures due to the Ebola virus.',
            linkText: 'Read more',
            linkUrl: '/uk/english/help/travel-updates/#6616'
        },
        {
            id: 'first-class-lounge-concourse-c',
            title: 'Improvements to our First Class Lounge on Concourse C',
            body: 'We’re transforming our First Class Lounge on Concourse C in Terminal 3 at Dubai International Airport. While we make these improvements, the lounge will be closed.',
            linkText: 'Read more',
            linkUrl: '/uk/english/help/travel-updates/#6586'
        },
        {
            id: 'travel-to-european-union',
            title: 'Travel to the European Union',
            body: 'The European Union has introduced a new Entry/Exit System at Schengen borders, replacing the manual passport stamping process.',
            linkText: 'Read more',
            linkUrl: '/uk/english/help/travel-updates/#6556'
        },
        {
            id: 'uk-travel-requirements',
            title: 'Travel requirements for the United Kingdom',
            body: 'Travel requirements to the UK are changing, including Electronic Travel Authorisation and updates to eVisas.',
            linkText: 'Read more',
            linkUrl: '/uk/english/help/travel-updates/#6477'
        },
        {
            id: 'manchester-terminal-change',
            title: 'Manchester Airport Terminal Change',
            body: 'Effective 18th November 2025, Emirates flights will operate to and from Terminal 2 at Manchester Airport.',
            linkText: 'Read more',
            linkUrl: '/uk/english/help/travel-updates/#6463'
        }
    ];

    cm.announcementsJson = angular.toJson(cm.announcements);
}
})();
